import React from 'react';
import { palette } from './theme';

/**
 * Same shape and wording as the two tenant apps' footer
 * (frontend-regiform-ims/src/components/layout/Footer.js), so the three sites
 * read as one product.
 *
 * Styled inline rather than through a shared stylesheet: this bundle is
 * deliberately separate from the tenant frontends and does not import their
 * main.css, so a `.app-footer` class here would carry no styling.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <div style={{ textAlign: 'center', padding: '12px 0', marginTop: 8,
                  borderTop: `1px solid ${palette.gridline}` }}>
      <span style={{ fontSize: 12, color: palette.inkMuted, letterSpacing: 0.2 }}>
        © {year} SLB Group · Powered by{' '}
        <a href="https://autone.lk" target="_blank" rel="noopener noreferrer"
           style={{ color: palette.inkSecondary, fontWeight: 500, textDecoration: 'none' }}>
          Autone
        </a>
      </span>
    </div>
  );
}
